import React from 'react';
import Header from '../../components/common/Header/Header';
import Footer from '../../components/common/Footer/Footer';
// Import leadership image from assets
import leadershipImage from '../../assets/images/sunil3.jpg'; 

const OurProfile = () => {
  const styles = {
    container: {
      fontFamily: 'Arial, sans-serif',
      lineHeight: '1.6',
      color: '#333'
    },
    heroSection: {
      backgroundColor: '#2d5016',
      color: 'white',
      padding: '80px 0',
      textAlign: 'center'
    },
    heroTitle: {
      fontSize: '3rem',
      fontWeight: 'bold',
      marginBottom: '1rem'
    },
    heroSubtitle: {
      fontSize: '1.2rem',
      opacity: '0.9'
    },
    section: {
      padding: '60px 0',
      maxWidth: '1200px',
      margin: '0 auto',
      paddingLeft: '2rem',
      paddingRight: '2rem'
    },
    sectionTitle: {
      fontSize: '2.5rem',
      fontWeight: 'bold',
      marginBottom: '2rem',
      color: '#2d5016'
    },
    contentGrid: {
      display: 'grid',
      gridTemplateColumns: '1fr 1fr',
      gap: '3rem',
      alignItems: 'center',
      marginBottom: '3rem'
    },
    imageContainer: {
      position: 'relative',
      borderRadius: '10px',
      overflow: 'hidden',
      boxShadow: '0 10px 30px rgba(0,0,0,0.1)'
    },
    leadershipImage: {
      width: '100%',
      height: '400px',
      objectFit: 'cover'
    },
    textContent: {
      fontSize: '1.1rem',
      lineHeight: '1.8'
    },
    brandName: {
      color: '#22c55e',
      fontWeight: 'bold'
    },
    highlight: {
      color: '#f97316',
      fontWeight: 'bold'
    },
    featureGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
      gap: '2rem',
      marginTop: '3rem'
    },
    featureCard: {
      backgroundColor: '#f8f9fa',
      padding: '2rem',
      borderRadius: '10px',
      textAlign: 'center',
      border: '2px solid transparent',
      transition: 'all 0.3s ease'
    },
    featureIcon: {
      fontSize: '3rem',
      marginBottom: '1rem'
    },
    featureTitle: {
      fontSize: '1.5rem',
      fontWeight: 'bold',
      marginBottom: '1rem',
      color: '#2d5016'
    },
    statsSection: {
      backgroundColor: '#2d5016',
      color: 'white',
      padding: '60px 0',
      textAlign: 'center'
    },
    statsGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
      gap: '2rem',
      maxWidth: '1000px',
      margin: '0 auto'
    },
    statNumber: {
      fontSize: '3rem',
      fontWeight: 'bold',
      color: '#22c55e'
    },
    statLabel: {
      fontSize: '1.1rem',
      marginTop: '0.5rem'
    }
  };

  return (
    <div style={styles.container}>
      <Header />
      
      {/* Hero Section */}
      <section style={styles.heroSection}>
        <div style={styles.section}>
          <h1 style={styles.heroTitle}>About Siridharini</h1>
          <p style={styles.heroSubtitle}>
            Pioneering Sustainable Agriculture & Premium Farmland Investment
          </p>
        </div>
      </section>

      {/* Main Content Section */}
      <section style={styles.section}>
        <h2 style={styles.sectionTitle}>Our Story</h2>
        <div style={styles.contentGrid}>
          <div style={styles.imageContainer}>
            <img 
              src={leadershipImage} 
              alt="Siridharini Leadership" 
              style={styles.leadershipImage}
            />
          </div>
          <div style={styles.textContent}>
            <p>
              <span style={styles.brandName}>Siridharini</span> is a pioneering agricultural enterprise specializing in sustainable farming and premium farmland investment opportunities. 
              Founded with the vision that <span style={styles.highlight}>"Money Does Grow On Trees"</span>, we have established ourselves as leaders in 
              sandalwood cultivation, mixed crop farming, and agricultural innovation.
            </p>
            <p>
              Our approach combines traditional farming wisdom with modern agricultural techniques to create thriving ecosystems that benefit both investors 
              and the environment. We focus on high-value crops including sandalwood, teak, mahogany, and various fruit trees, ensuring sustainable returns 
              while preserving the natural beauty of our land.
            </p>
            <p>
              With over a decade of experience in agricultural management, <span style={styles.brandName}>Siridharini</span> has built a reputation for 
              excellence in sustainable farming practices. Our team of agricultural experts ensures that every aspect of cultivation, from soil preparation 
              to harvest, is managed with the highest standards of quality and care.
            </p>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section style={styles.section}>
        <h2 style={styles.sectionTitle}>Why Choose Siridharini</h2>
        <div style={styles.featureGrid}>
          <div style={styles.featureCard}>
            <div style={styles.featureIcon}>🌱</div>
            <h3 style={styles.featureTitle}>Sustainable Farming</h3>
            <p>100% organic farming methods that preserve soil health and biodiversity while ensuring premium quality produce.</p>
          </div>
          <div style={styles.featureCard}>
            <div style={styles.featureIcon}>🏞️</div>
            <h3 style={styles.featureTitle}>Premium Farmland</h3>
            <p>Carefully selected fertile land with optimal growing conditions for high-value crops and sustainable agriculture.</p>
          </div>
          <div style={styles.featureCard}>
            <div style={styles.featureIcon}>🎯</div>
            <h3 style={styles.featureTitle}>Expert Management</h3>
            <p>Professional agricultural management with 24/7 monitoring, ensuring optimal crop health and maximum yields.</p>
          </div>
          <div style={styles.featureCard}>
            <div style={styles.featureIcon}>🏡</div>
            <h3 style={styles.featureTitle}>Luxury Amenities</h3>
            <p>Farmhouse, clubhouse, and recreational facilities that provide a perfect weekend retreat in nature.</p>
          </div>
          <div style={styles.featureCard}>
            <div style={styles.featureIcon}>💚</div>
            <h3 style={styles.featureTitle}>Environmental Impact</h3>
            <p>Contributing to environmental conservation through reforestation and sustainable agricultural practices.</p>
          </div>
          <div style={styles.featureCard}>
            <div style={styles.featureIcon}>📈</div>
            <h3 style={styles.featureTitle}>Growing Returns</h3>
            <p>Long-term value appreciation through premium crop cultivation and land development.</p>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section style={styles.statsSection}>
        <div style={styles.section}>
          <h2 style={{...styles.sectionTitle, color: 'white'}}>Our Impact</h2>
          <div style={styles.statsGrid}>
            <div>
              <div style={styles.statNumber}>500+</div>
              <div style={styles.statLabel}>Acres Under Cultivation</div>
            </div>
            <div>
              <div style={styles.statNumber}>50+</div>
              <div style={styles.statLabel}>Crop Varieties</div>
            </div>
            <div>
              <div style={styles.statNumber}>10+</div>
              <div style={styles.statLabel}>Years of Experience</div>
            </div>
            <div>
              <div style={styles.statNumber}>100%</div>
              <div style={styles.statLabel}>Organic Farming</div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default OurProfile;